<template>
  <div>
    <div
      id="modal-checklist"
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      role="dialog"
      tabindex="-1"
      v-if="ocultar_checklist_info == false"
    >
      <div class="modal-dialog modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
            @click="cerrarNoMostrar"
          >
            <span class="close-label">No mostrar de nuevo</span>
            <span class="os-icon os-icon-close"></span>
          </button>

          <div class="onboarding">
            <div class="onboarding">
              <div class="onboarding-media">
                <img alt="" src="img/bigicon2.png" width="200px" />
              </div>
              <div class="onboarding-content">
                <h4 class="onboarding-title">Lista de Revisión Diaria</h4>
                <div class="onboarding-text">
                  <b>
                    Lista de tareas que debe realizar el usuario día a día, son
                    tareas de alta prioridad y que deben ser ejecutadas si o si
                    por el usuario.
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-for="tienda in user_profile.checklist_tienda" :key="tienda.tienda">
      <div
        class="element-wrapper"
        v-for="current in filtrado_por_tienda(tienda)"
        :key="current.id"
      >
        <h6 class="element-header">
          {{ current.nombre }} asignado a {{ user_profile.name }}
        </h6>
        <div class="element-box-tp mb-3">
          <div class="table-responsive">
            <table class="table table-padded">
              <thead>
                <tr>
                  <th>Tarea</th>
                  <th>Link</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="detalle in current.detalle" :key="detalle.id">
                  <td>
                    <span :title="detalle.descripcion">
                      <b>{{ detalle.nombre }}</b>
                    </span>
                    <div
                      class="smaller"
                      v-for="log in detalle.tiendas_completadas"
                      :key="log.id"
                    >
                      <span :title="detalle.descripcion">
                        {{ log.fecha_completada }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <a v-if="detalle.link_ayuda != null && detalle.link_ayuda != '' " :href="detalle.link_ayuda + '?tienda ' + tienda.tienda" target="_blank">Ver</a>
                  </td>
                  <td class="text-center">
                       <span
                      v-if="detalle.tiendas_completadas.length > 0"
                      class="badge badge-success"
                      href=""
                      >Completado</span
                    >
                    <button
                      v-if="detalle.tiendas_completadas.length == 0"
                      class="btn btn-md badge-danger"
                      @click="listo(tienda, detalle)"
                    >
                      Listo !
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: ["user_profile"],
  data() {
    return {};
  },
  computed: {
    ocultar_checklist_info() {
      if (localStorage.getItem(this.get_default_var_local_storage()) == "true") {
        return true;
      }
      return false;
    },
    
  },
  mounted() {
    let self = this;
    console.log(self.user_profile)
    $("#modal-checklist").modal();
  },
  methods: {
    get_default_var_local_storage(){
      let self = this;
      return self.user_profile.id + "--ocultar_checklist_info"
    },
    filtrado_por_tienda(ch_tienda){
        return this.user_profile.checklist.filter(c => {
           return ((c.id == ch_tienda.lista_verificacion));
        });
    },
    listo(tienda, det){
        let self = this;

        let params = Object.assign({}, tienda);
        params.lista_verificacion_detalle = det.id;

        DynamicService.getActionList(
            "dashboard",
            "dashboard-user",
            "completar_checklist",
            params
        ).then((response) => {
            self.refreshProfile();
        });
    },
    cerrarNoMostrar() {
      localStorage.setItem(this.get_default_var_local_storage(), true);
    },
    refreshProfile: function () {
      let self = this;
      DynamicService.getActionList(
        "dashboard",
        "dashboard-user",
        "checklist"
      ).then((response) => {
        self.user_profile = response.data;
      });
    },
    
  },
};
</script>
